import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Service from "../Service/http";
import moment from "moment";
import { useNavigate } from 'react-router-dom'
import "./Attendance.css";
import Pagination from "@mui/material/Pagination";
import { ClipLoader, FadeLoader } from "react-spinners";
import { FaDownload } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import * as xlsx from 'xlsx'

function AttendanceSession() {

  const service = new Service();

  let [attendanceSession, setAttendanceSession] = useState(null);
  let [attendanceSessions, setAttendanceSessions] = useState([]);
  let [pages, setPages] = useState(1);
  let [page, setPage] = useState(1);
  let [attendanceFilter, setAttendanceFilter] = useState(null);
  let [batches, setBatches] = useState([]);
  let [loading, setLoading] = useState(false);
  let [refresh, setRefresh] = useState(false);
  let [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [selectedSessionsId, setSelectedSessionsId] = useState([])
  const [fetchingAttendance, setFetchingAttendance] = useState(false)
  const [selectedBatchName, setSelectedBatchName] = useState('')

  const selectAllInputRef = useRef(null);

  const getBatches = () => {
        service
        .get("api/getBatches?isActive=true")
      .then((json) => {
        setBatches(json);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const getAttendanceSessions = () => {
    let batchId = attendanceFilter?.batch_id;
    service
      .get(`api/attendance-session/batch/${batchId}?page=${page}&pageSize=${pageSize}}`)
      .then((json) => {
        let totalCount = json['totalCount'];
        let data = json['data'];
        setPages(Math.ceil(totalCount/pageSize));
        setAttendanceSessions(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const updateDelete = (attendance_session_id, status) => {
    service
      .post("api/attendance-session/update", { attendance_session_id, "is_deleted":status })
      .then((json) => {
        setLoading(false);
        toast.success("saved");
      })
      .catch((error) => {
        toast.error("Someting went wrong");
      });
  };

  useEffect(() => {
    getAttendanceSessions();
    getBatches();
  }, [page, attendanceFilter, refresh, pageSize]);

  const addAttendanceSession = () => {
    if (attendanceSession.session_name === null) {
      toast.error("Name cannot be empty");
      return;
    } else if (attendanceSession.batch_id === null) {
      toast.error("Batch cannot be empty");
      return;
    } else if (attendanceSession.session_start_time === null) {
      toast.error("Start Time cannot be empty");
      return;
    } else if (attendanceSession.session_end_time === null) {
      toast.error("End Time cannot be empty");
      return;
    } else if (attendanceSession.session_start_time > attendanceSession.session_end_time) {
      toast.error("Start Time cannot be greater than End Time");
      return;
    }
    setLoading(true);

    service
      .post("api/attendance-session", attendanceSession)
      .then((json) => {
        navigate('/attendance-session/' + json._id)
        setLoading(false);
        setRefresh(!refresh)
        getAttendanceSessions();
        toast.success("Success");
      })
      .catch((error) => {
        toast.error("Error");
      });
  };

  const dataToXLSX = (attendanceData) => {
    
    let studentRecords = {};
    let dates = Object.keys(attendanceData);

    dates.forEach(date => {
        Object.keys(attendanceData[date]).forEach(studentId => {
            const student = attendanceData[date][studentId];
            const key = student.email || studentId; // Using email as unique identifier
            if (!studentRecords[key]) {
                studentRecords[key] = {
                    name: student.name,
                    rollNumber: student.rollNumber || "N/A",
                };
            }
            studentRecords[key][date] = student.status;
        });
    });

    const excelData = [];
    const headers = ['Name', 'Roll Number', ...dates]; // First row: column headers
    excelData.push(headers);

    Object.values(studentRecords).forEach(student => {
        const row = [student.name, student.rollNumber];
        dates.forEach(date => {
            row.push(student[date] || 'N/A'); // 'N/A' if no status available
        });
        excelData.push(row);
    });

    const worksheet = xlsx.utils.aoa_to_sheet(excelData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Attendance");

    xlsx.writeFile(workbook, `${selectedBatchName}.xlsx`);    
  }

  const handleBatchAttendanceDownload =  async () => {

      try {
        
        setFetchingAttendance(true);
        const response = await service.post(`api/attendance/${attendanceFilter.batch_id}`, { sessions : selectedSessionsId })
        dataToXLSX(response.data);
        toast.success('Downloaded Attendance Successfully !')

      } catch (error) {

        toast.error(`Unable to download attendance for ${selectedBatchName} !`)
        console.error(`Unable to download attendance for ${selectedBatchName} !`)

      } finally {
        setFetchingAttendance(false);
      }

  }

  const handleSessionSelect = (id) => {

    if(selectedSessionsId.includes(id)) setSelectedSessionsId(selectedSessionsId.filter((current_id) => current_id !== id));
    else setSelectedSessionsId([...selectedSessionsId, id]);

  }

  const handleSelectAll = (e) => {

    if(selectedSessionsId.length === attendanceSessions.length && !e.target.checked) setSelectedSessionsId([]);
    else setSelectedSessionsId(attendanceSessions.map((session) => session._id));

  }

  return (
    <div>
      <div id="attendanceSessionContainer" className="container shadow bg-white mb-5">
        <h3 className="text-primary mt-3 mb-3 text-center"><strong>ATTENDANCE SESSIONS</strong></h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            addAttendanceSession();
            e.target.reset();
          }}
        >
          <div className="row">
            <div className=" col-lg-6 col-md-12 col-sm-12 mt-4  ">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Attendance Session Name </span>
                </b>
              </div>

              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  required
                  type="text"
                  placeholder="Enter Session Name"
                  name="session_name"
                  onChange={(e) => {
                    let temp = { ...attendanceSession };
                    temp["session_name"] = e.target.value;
                    setAttendanceSession(temp);
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12  col-sm-12 mt-5">
              <div className="input-group ">
                <label className="p-1 input-group-text text-primary ps-2">Select Batch</label>
                <select
                  className="form-select text-primary"
                  name="batch"
                  required
                  onChange={(e) => {
                    if (e.target.value !== "select") {
                      let temp = { ...attendanceSession };
                      temp["batch_id"] = e.target.value;
                      setAttendanceSession(temp);
                    }
                  }}
                >
                  {" "}
                  <option value=""></option>
                  {batches.map((ele, ind) => {
                    return (
                      <option key={ele.batch_name} value={ele._id}>
                        {ele.batch_name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className=" col-lg-6 col-md-12 col-sm-12 mt-4  ">
              <div className="text-start">
                <b>
                  <span className="text-warning"> Start Time</span>
                </b>
              </div>
              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  required
                  type="datetime-local"
                  name="session_start_time"
                  onChange={(e) => {
                    let temp = { ...attendanceSession };
                    temp["session_start_time"] = e.target.value;
                    setAttendanceSession(temp);
                  }}
                />
              </div>
            </div>
            <div className=" col-lg-6 col-md-12 col-sm-12 mt-4  ">
              <div className="text-start">
                <b>
                  <span className="text-warning"> End Time</span>
                </b>
              </div>
              <div className="input-group mb-2">
                <input
                  className="form-control text-primary font-monospace"
                  required
                  type="datetime-local"
                  name="session_end_time"
                  onChange={(e) => {
                    let temp = { ...attendanceSession };
                    temp["session_end_time"] = e.target.value;
                    setAttendanceSession(temp);
                  }}
                />
              </div>
            </div>
            <div className="me-5 mb-4 mt-4">
              <button type="submit" className="btn btn-primary float-end px-5">
                Create Session
              </button>
            </div>
          </div>
        </form>
        
        {/* Creating Filter for the batches */}
        <div className="input-group " style={{ marginBottom: '10px'}}>
          <label className="p-1 input-group-text text-primary ps-2">Select Batch</label>
          <select
            className="form-select text-primary"
            name="batch"
            required
            onChange={(e) => {
              if (e.target.value !== "select") {
                let temp = { ...attendanceFilter };
                if(e.target.value !== "") temp["batch_id"] = e.target.value;
                else temp = null;
                
                const result = batches.find(batch => batch._id === e.target.value);

                if(result) setSelectedBatchName(result?.batch_name);
                setAttendanceFilter(temp);
                setPage(1);
                
              } 

              setSelectedSessionsId([])
              if(selectAllInputRef && selectAllInputRef.current) selectAllInputRef.current.checked = false;
            }}
          >
            {" "}
            <option value="">No Filter</option>
            {batches.map((ele, ind) => {
              return (
                <option key={ele.batch_name} value={ele._id}>
                  {ele.batch_name}
                </option>
              );
            })}
          </select>
        </div>

        <div className="d-flex justify-content-end">
            <Tooltip title="Download Batch Attendance" placement="left">
                <span>
                  <button 
                    className={`bg-${attendanceFilter && selectedSessionsId.length > 0 ? 'primary' : 'secondary'} text-${attendanceFilter && selectedSessionsId.length > 0 ? 'white' : 'dark'} custom-button my-2`} 
                    onClick={handleBatchAttendanceDownload}
                    disabled={!(attendanceFilter && selectedSessionsId.length > 0)}
                    >
                      { fetchingAttendance ? <ClipLoader size={15} color='white' /> : <FaDownload/> }

                  </button>
                </span>
            </Tooltip>
        </div>
      <div className="w-100 overflow-auto">
        <table id="attendanceSessionsTable">
          <thead>
            <tr className="bg-light text-center ">
              <th className="text-center">S. No</th>
              <th className="text-center">Session Name</th>
              <th className="text-center">Batch</th>
              <th className="text-center">Date</th>
              <th className="text-center">Timings</th>
              <th className="text-center">Created By</th>
              <th className="text-center">Attendance Taken By</th>
              <th className="text-center">Delete</th>
              {attendanceFilter && <th className="text-center">
                <div className="d-flex justify-content-center align-items-center">
                  <span>Select</span>
                  <Tooltip title="Select All">
                    <input 
                      type="checkbox" 
                      className="mx-2" 
                      style={{cursor: 'pointer'}} 
                      onChange={handleSelectAll}
                      ref={selectAllInputRef}
                    />
                  </Tooltip>
                </div>
              </th>}
            </tr>
          </thead>
          <tbody>
            {loading ? <div></div> : 
            attendanceSessions.map((ele, ind) => {
                return (
                  <tr key={ind} className="text-center">
                    <td className="text-secondary">{(page-1)*pageSize + ind+1}</td>
                    <td className="text-secondary"><a href={"attendance-session/" + ele._id}>{ele.session_name}</a></td>
                    <td className="text-center align-center">{ele.batch_id.batch_name}</td>
                    <td className="text-secondary">{moment(new Date(ele?.session_start_time)).format('Do MMM')}</td>
                    <td className="text-secondary">{moment(new Date(ele?.session_start_time)).format('h:mma')} - {moment(new Date(ele?.session_end_time)).format('h:mma')}</td>
                    <td className="text-center align-center">{ele.created_by.name}</td>
                    <td  className="text-center align-center">{ele.attendance_taken_by}</td>
                    <td className="text-center align-center">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={ele.is_deleted}
                          onChange={(e) => {
                            let obj = [...attendanceSessions];
                            obj[ind].is_deleted = e.target.checked;
                            setAttendanceSessions(obj);
                            updateDelete(ele._id, e.target.checked);
                          }}
                        />
                        <label className="text-muted form-check-label">
                          Delete
                        </label>
                      </div>
                    </td>
                    {attendanceFilter && <td>
                      <input type="checkbox"
                         onChange={() => handleSessionSelect(ele._id)}
                         checked={selectedSessionsId.includes(ele._id)}
                      />
                    </td>}
                  </tr>
                );
            })}
          </tbody>
        </table>
      </div>
        <div className="row justify-content-between align-items-center">
          <div className="col-auto pt-3">
            <select className="form-select" 
            onChange={(e) =>{
              setLoading(true);
              setPageSize(parseInt(e.target.value));
              setPage(1);
            }}
          >
              <option>10</option>
              <option>20</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
            </select>
          </div>
          {loading? <div className="col-auto"><FadeLoader color={"skyblue"}/></div> : <div className="col-auto"></div>}
          <div className="col-auto pt-3">
            <Pagination
              count={pages}
              color="primary"
              defaultPage={1}
              page={page}
              onChange={(e, v) => {
                setPage(v);
                setLoading(true);
              }}
              variant="outlined"
              shape="rounded"
              siblingCount={1}
              showFirstButton
              showLastButton
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceSession;
